export default __webpack_public_path__ + "static/media/info.816b591f.svg";